import { getYotpoParams } from "./yotpoConfig";
import { useLocale } from "next-intl";

export const useYotpoReviews = () => {
    const locale = useLocale();
    const locales = process.env.NEXT_PUBLIC_LOCALES?.split(",") ?? [];
    const { yotpoAppId, yotpoInstanceId, yotpoEnabled } = getYotpoParams(locales, locale);

    return {
        isYotpoReviewsEnabled: yotpoEnabled,
        yotpoAppId,
        yotpoInstanceId,
    };
};
